<template>
    <div class="introduction">
        
        <div class="protrack-container">
            <div class="logo">
                <img src="../../assets/logo_combined.png" height="50px" style="border-radius: 15px"/>
            </div>
            <div v-if="routeInCohort">
                <!-- <div class="protrack-text">{{ this.cohortName }}</div> -->
                
                <!-- <div class="logo">
                    <img src="../assets/logo_combined.png" height="50px" style="border-radius: 15px"/>
                </div> -->
                <!-- <div>{{ this.studyReference }}</div> -->
                
                <!-- <div class="protrack-text">ProTrack: <br>Melanoma PTRC</div>
                <div class="logo">
                    <img src="../../assets/logo_combined.png" height="50px" style="border-radius: 15px"/>
                </div> -->
                <!-- <div>Select a cohort below:</div> -->
                 <!-- <br> -->
                <Tabs/>
            </div>
            <!-- <dynamic-header/> -->
        </div>
        
        <div class="cptac-description">
            <div class="static-title">ProTrack: Melanoma</div>
            <p>This interactive data portal supports query, visualization, and downloads of multi-omics data from two comprehensive proteogenomic studies to understand mechanisms and drivers of immune activity in melanoma, collaborative projects by <a href="https://proteomics.cancer.gov/programs/cptac">Clinical Proteomic Tumor Analysis Consortium (<b>CPTAC</b>).</a>.</p>
            
            <p>NCI-supported CPTAC is a comprehensive and coordinated effort to accelerate the understanding of the molecular basis of cancer through the application of large-scale proteome (proteins) and genome (DNA and RNA) analysis technologies to different cancer types. Through collaboration with leaders in the field, CPTAC’s mission is to accelerate precision oncology through state-of-the-art proteogenomics and create open-source community resources.</p>

            
        </div>

    </div>
</template>

<script>

import Tabs from '../../Routerpages/Tabs.vue'
// import StaticHeader from './StaticHeader.vue';
// import DynamicHeader from './DynamicHeader.vue';

export default {
        name: "introduction",
        components: {
            Tabs,
            // StaticHeader,
            // DynamicHeader

        },
        computed: {
            cohortName() { 
                const routesKey = Object.keys(this.$store.state.router_to_headerInfo)
                const currentRoute = this.$route.path
                if (routesKey.includes(currentRoute)) {
                    return this.$store.state.router_to_headerInfo[currentRoute][0]
                } else {
                    return ''
                }
                // return this.$store.state.Header_cohortName 
            },
            studyReference() { 
                const routesKey = Object.keys(this.$store.state.router_to_headerInfo)
                const currentRoute = this.$route.path
                if (routesKey.includes(currentRoute)) {
                    return this.$store.state.router_to_headerInfo[currentRoute][1]
                } else {
                    return ''
                }
            },
            routeInCohort() {
                const routesKey = Object.keys(this.$store.state.router_to_headerInfo)
                const currentRoute = this.$route.path
                return routesKey.includes(currentRoute)
            }
        // studyReference() { return this.$store.state.Header_studyReference },
        }
    }
    
</script>

<style scoped>
    .introduction {
        background: #91818a;
        padding: 0.5em;
        color: white;
        display: flex;
    }

    .protrack-container {
        /* font-weight: bold;
        font-size: 1.5em; */
        margin-right: 1em;
        min-width: 25%;
        max-width: 25%;
        text-align: right;
    }

    .protrack-text {
        font-weight: bold;
        font-size: 1.5em;
        /* margin-right: 1em;
        min-width: 20%;
        max-width: 20%; */
        text-align: right;
    }

    .static-title {
        font-weight: bold;
        font-size: 2em;
        /* margin-right: 1em;
        min-width: 20%;
        max-width: 20%; */
        text-align: left;
    }


    /* .logo {
        border-radius: 50%;
        border:1px solid black;
    } */
    
    .cptac-description {
        font-size: 0.85em;
        min-width: 70%;
        max-width: 70%;
    }

    .cptac-description a {
        color: white;
        font-weight: bold;
        text-decoration: underline;
    }
</style>